import type { ReactNode } from "react";

/** The centred card of the account pages (email verification, password reset). */
export default function AuthCardPage({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="app-surface-muted flex min-h-screen items-center justify-center p-6">
      <div className="app-card w-full max-w-sm p-6 shadow-sm">
        <h1 className="app-title mb-3 text-xl font-semibold">{title}</h1>
        {children}
      </div>
    </div>
  );
}
